import React from "react"
import PropTypes from "prop-types"
import { Field } from "redux-form"

const Prefix = ({value}) => (
  value ? <div style={{position: "absolute", top: "38px", left: "30px"}}>{value}</div> : null
)

Prefix.propTypes = {value: PropTypes.string}

const InputComponent = ({input, meta: {error}, label, type, disabled, prefix, min, step}) => {
  return (
    <label style={{position: "relative"}}>
      {label}
      <Prefix value={prefix} />
      <input {...input} type={type} disabled={disabled} min={min} step={step} />
      {error && error.map((e, i) => <div key={i} className="error_container">{e}</div>)}
    </label>
  )
}

const Input = (props) => {
  return props.type === "number"
    ? <Field component={InputComponent} {...props} min="0" step="0.01" />
    : <Field component={InputComponent} {...props} />
}

Input.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string,
  prefix: PropTypes.string,
  type: PropTypes.string,
}

export default Input
